<template>
  <div ref="buttonApp" class="app-button">
    <div class="app-button__inner">
      <UiButton
        v-if="isMobile"
        tag="a"
        :href="appLink || 'https://m.imast.am/PfkZ/yz5m2oko'"
        target="_blank"
        class="qrcode-modal__button"
      >
        {{ $t('button.go_to_app') }}
      </UiButton>
      <div v-else class="qrcode-modal">
        <Modal width="427" @open="setButtonPadding" @close="setButtonPadding">
          <template #activator="{ onClick }">
            <UiButton class="qrcode-modal__button" @click="onClick">
              {{ $t('button.go_to_app') }}
            </UiButton>
          </template>
          <template #content>
            <div class="qrcode-modal__content">
              <Loader
                v-if="isLoadingAppLink"
                icon-width="44"
                icon-height="44"
              />
              <div v-else class="qr-code" v-html="appQrCode"></div>
              <div class="qrcode-modal__description">
                {{ $t('qrcode_text') }}
              </div>
            </div>
          </template>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script setup>
import camelcaseKeys from 'camelcase-keys';

const { $useApi } = useNuxtApp();

const appLink = ref(null);
const appQrCode = ref(null);
const isLoadingAppLink = ref(false);

const buttonApp = useTemplateRef('buttonApp');
const { isMobile } = useMobileDevice();

onMounted(() => {
  setBodyPadding();
  getAppLink();
});

async function getAppLink() {
  isLoadingAppLink.value = true;
  const unicId = useRoute().params.id;
  let getLinkUrl;

  switch (useRoute().name) {
    case 'p-id':
      getLinkUrl = $useApi.project.appLink(unicId);
      break;
    case 'i-id':
      getLinkUrl = $useApi.profile.appLink(unicId);
      break;
    case 'f-id':
      getLinkUrl = $useApi.fund.appLink(unicId);
      break;
    case 'n-id':
      getLinkUrl = $useApi.news.appLink(unicId);
      break;
    default:
      getLinkUrl = $useApi.sharing.appLink(unicId);
  }

  try {
    const response = await $fetch(getLinkUrl, {
      headers: useCustomRequestHeaders(),
    });

    const { appLink: linkToApp, appLinkQrCode: qrCode } = camelcaseKeys(
      response,
      {
        deep: true,
      }
    );

    appLink.value = linkToApp;
    appQrCode.value = updateSvgSize(qrCode);
  } catch (error) {
    console.log(error);
  } finally {
    isLoadingAppLink.value = false;
  }
}

function setBodyPadding() {
  nextTick(() => {
    document.body.style.paddingBottom = buttonApp.value?.scrollHeight + 'px';
  });
}

function setButtonPadding({ padding }) {
  buttonApp.value.style.marginRight = padding ? padding + 'px' : null;
}

function updateSvgSize(svgText) {
  return svgText
    .replace(/(<svg[^>]*?)\swidth="[^"]*"/, '$1 width="100%"')
    .replace(/(<svg[^>]*?)\sheight="[^"]*"/, '$1 height="100%"');
}
</script>

<style lang="scss">
@use '@/assets/styles/components/modal/qrcode-modal.scss' as *;
</style>
